import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

interface ReportNotFoundProps {
  onBack: () => void;
}

export const ReportNotFound = ({ onBack }: ReportNotFoundProps) => {
  return (
    <div className="text-center p-8">
      <p className="text-muted-foreground">Rapport non trouvé</p>
      <Button onClick={onBack} className="mt-4">
        <ArrowLeft className="h-4 w-4 mr-2" />
        Retour
      </Button>
    </div>
  );
};